import React from 'react'
import {
  LinearProgress,
  TextField,
  Button,
} from "@material-ui/core";
import {Alert} from "@material-ui/lab";

import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  formControl: {
    margin: `${theme.spacing(2)}px 0`,
    minWidth: 400,
    maxWidth: 500,
    width: 400,
  },
}));


export default function PasswordResetForm({formData, submitText, onChange, onSubmit, loading, errorMsg, success}) {
  const classes = useStyles();

  const fieldChange = e => {
    onChange(e, e.target.name);
  };

  return (
    <form className={classes.form} noValidate onSubmit={onSubmit}>
      <p>&nbsp;</p>
      <TextField
        variant="outlined"
        margin="normal"
        required
        fullWidth
        name="email"
        label="Email"
        type="email"
        id="password"
        value={formData.email}
        onChange={fieldChange}
      />

      <TextField
        variant="outlined"
        margin="normal"
        required
        fullWidth
        name="password"
        label="New Password"
        type="password"
        id="password"
        autoComplete="current-password"
        value={formData.password}
        onChange={fieldChange}
      />
      <TextField
        variant="outlined"
        margin="normal"
        required
        fullWidth
        name="password2"
        label="Confirm Password"
        type="password"
        id="password2"
        autoComplete="current-password"
        value={formData.password2}
        onChange={fieldChange}
      />

      {loading && <LinearProgress />}
      {errorMsg && errorMsg.length > 0 && (
        <Alert severity="error">{errorMsg}</Alert>
      )}

      {success && (
        <Alert severity="success">Account password successfully updated</Alert>
      )}

      <Button
        type="submit"
        fullWidth
        variant="contained"
        color="primary"
        className={classes.submit}
      >
        {submitText}
      </Button>
    </form>
  )
}
